import ApiService from '../../services/api.service';

export const fetchListaEmpresas = async ({ commit }) => {
  commit('user/initRequest', null, { root: true });
  const url = ApiService.getEndpoint('/admin/empresa/listar');
  try {
    commit('user/fetchRequest', true, { root: true });
    let response = await ApiService.get(url);
    return response.data.data;
  } catch (err) {
    console.log(err.response);
    commit(
      'user/setError',
      {
        isError: true,
        errorMessage: err.response ? err.response.data.message : err.message
      },
      { root: true }
    );
    return false;
  } finally {
    commit('user/finishRequest', null, { root: true });
  }
};

export const fetchListaUsuariosEmpresa = async ({ commit }) => {
  commit('user/initRequest', null, { root: true });
  const url = ApiService.getEndpoint('/admin/usuarioEmpresa/listar');
  try {
    commit('user/fetchRequest', true, { root: true });
    let response = await ApiService.get(url);
    console.log(response);
    return response.data.data;
  } catch (err) {
    console.log(err.response);
    commit(
      'user/setError',
      {
        isError: true,
        errorMessage: err.response ? err.response.data.message : err.message
      },
      { root: true }
    );
    return false;
  } finally {
    commit('user/finishRequest', null, { root: true });
  }
};

export const fetchCambiarEstadoUsuarioEmpresa = async ({ commit }, body) => {
  commit('user/initRequest', null, { root: true });
  const url = ApiService.getEndpoint('/admin/empresa/cambiarEstadoUsuario');
  try {
    commit('user/fetchRequest', true, { root: true });
    let response = await ApiService.post(url, body);
    console.log(response);
    return response.data.data;
  } catch (err) {
    console.log(err.response);
    commit(
      'user/setError',
      {
        isError: true,
        errorMessage: err.response ? err.response.data.message : err.message
      },
      { root: true }
    );
    return false;
  } finally {
    commit('user/finishRequest', null, { root: true });
  }
};

export const fetchCambiarEstadoEmpresa = async ({ commit }, body) => {
  commit('user/initRequest', null, { root: true });
  const url = ApiService.getEndpoint('/admin/empresa/cambiarEstado');
  try {
    commit('user/fetchRequest', true, { root: true });
    let response = await ApiService.post(url, body);
    console.log(response);
    return response.data.data;
  } catch (err) {
    console.log(err.response);
    commit(
      'user/setError',
      {
        isError: true,
        errorMessage: err.response ? err.response.data.message : err.message
      },
      { root: true }
    );
    return false;
  } finally {
    commit('user/finishRequest', null, { root: true });
  }
};

export const fetchListaAlumnosUNI = async ({ commit }) => {
  commit('user/initRequest', null, { root: true });
  const url = ApiService.getEndpoint('/admin/usuarioUNI/listar');
  try {
    commit('user/fetchRequest', true, { root: true });
    let { data } = await ApiService.get(url);
    commit('setListaAlumnosUNI', data.data);
    commit('setListaAlumnosUNIbackup', data.data);
  } catch (err) {
    commit(
      'user/setError',
      {
        isError: true,
        errorMessage: err.response ? err.response.data.message : err.message
      },
      { root: true }
    );
    return false;
  } finally {
    commit('user/finishRequest', null, { root: true });
  }
};

export const fetchListaAlumnosUNIquery = async (
  { state, commit },
  parameters
) => {
  commit('user/initRequest', null, { root: true });
  let params = {};
  const url = ApiService.getEndpoint('/admin/usuarioUNI/buscar');
  for (let key in parameters) {
    let type = typeof key;
    switch (type) {
      case 'string':
        if (parameters[key] !== '') params[key] = parameters[key];
        break;

      case 'object':
        if (parameters[key].length) params[key] = parameters[key];
        break;

      default:
        break;
    }
  }

  params = { ...params, noLimit: true };

  // if (limit || page) {
  //   params = {
  //     ...params,
  //     limit,
  //     page
  //   };
  // } else {
  //   params = { ...params, noLimit: true };
  // }

  try {
    if (params) {
      commit('user/fetchRequest', true, { root: true });
      let { data } = await ApiService.get(url, { params });
      commit('setListaAlumnosUNI', data.data);
    } else {
      commit('setListaAlumnosUNI', state.listaAlumnosUNIbackup);
    }
  } catch (err) {
    commit(
      'user/setError',
      {
        isError: true,
        errorMessage: err.response ? err.response.data.message : err.message
      },
      { root: true }
    );
    return false;
  } finally {
    commit('user/finishRequest', null, { root: true });
  }
};

export const fetchGetAlumnoInformation = async ({ commit }, codigoUNI) => {
  commit('user/initRequest', null, { root: true });
  let url = ApiService.getEndpoint('/admin/perfil-alumno');
  url = ApiService.addQueryParams(url, { codigoUNI });
  try {
    commit('user/fetchRequest', true, { root: true });
    let {
      data: { data }
    } = await ApiService.get(url);
    commit('setSelectedAlumnoInfo', data);
  } catch (err) {
    console.log(err);
    commit(
      'user/setError',
      {
        isError: true,
        errorMessage: err.response ? err.response.data.message : err.message
      },
      { root: true }
    );
    return false;
  } finally {
    commit('user/finishRequest', null, { root: true });
  }
};

export const fetchUpdateDatosAlumno = async ({ commit }, body) => {
  commit('user/initRequest', null, { root: true });
  let result = false;
  const url = ApiService.getEndpoint('/admin/usuarioUNI/actualizar');
  try {
    commit('user/fetchRequest', true, { root: true });
    let { data } = await ApiService.post(url, {
      codigoUNI: body.codigoUNI,
      correoAlternativo: body.correoAlternativo,
      correoUNI: body.correoUNI
    });
    console.log('newData', data);
    result = true;
  } catch (err) {
    commit(
      'user/setError',
      {
        isError: true,
        errorMessage: err.response ? err.response.data.message : err.message
      },
      { root: true }
    );
    result = false;
  } finally {
    commit('user/finishRequest', null, { root: true });
  }
  return result;
};

export const fetchAdminPerfil = async ({ commit }) => {
  commit('user/initRequest', null, { root: true });
  const url = ApiService.getEndpoint('/admin/perfil');
  try {
    commit('user/fetchRequest', true, { root: true });
    let {
      data: { data }
    } = await ApiService.get(url);
    commit('setAdminData', data);
  } catch (err) {
    commit(
      'user/setError',
      {
        isError: true,
        errorMessage: err.response ? err.response.data.message : err.message
      },
      { root: true }
    );
    return false;
  } finally {
    commit('user/finishRequest', null, { root: true });
  }
};

export const fetchEstadisticaNuevosRegistro = async ({ commit }) => {
  commit('user/initRequest', null, { root: true });
  const url = ApiService.getEndpoint('/admin/estadisticas/nuevos-registros');
  try {
    commit('user/fetchRequest', true, { root: true });
    let {
      data: { data }
    } = await ApiService.get(url);
    commit('setEstadisticaNuevosIngresos', data);
  } catch (err) {
    commit(
      'user/setError',
      {
        isError: true,
        errorMessage: err.response ? err.response.data.message : err.message
      },
      { root: true }
    );
    return false;
  } finally {
    commit('user/finishRequest', null, { root: true });
  }
};

export const fetchListaAdministradores = async ({ commit }) => {
  let result = false;
  commit('user/initRequest', null, { root: true });
  const url = ApiService.getEndpoint('/admin/listar-admins');
  try {
    commit('user/fetchRequest', true, { root: true });
    let { data } = await ApiService.get(url);
    commit('setListaAdministradores', data.data);
    result = true;
  } catch (err) {
    commit(
      'user/setError',
      {
        isError: true,
        errorMessage: err.response ? err.response.data.message : err.message
      },
      { root: true }
    );
    result = false;
  } finally {
    commit('user/finishRequest', null, { root: true });
  }
  return result;
};

export const fetchEnviarNuevoCorreo = async ({ commit }, mail) => {
  let result = false;
  let params = {};
  commit('user/initRequest', null, { root: true });
  const url = ApiService.getEndpoint('/admin/usuarioUNI/correo-masivo');
  try {
    if (mail.filters.alumnosSeleccionados && !mail.filters.alumnosSeleccionados.length) {
      throw new Error('Tienes que seleccionar al menos 1 persona para el envío del correo');
    }

    for (const key in mail.filters) {
      if (mail.filters[key]) {
        params[key] = mail.filters[key];
      }
    }
    mail.filters = params;

    // debugger;
    const file = mail.adjunto;
    if (file && typeof file === 'object') {
      mail.adjunto = {
        name: file.name,
        type: file.type,
        data: await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result.replace(/^data:.+;base64,/, ''));
          reader.onerror = error => reject(error);
        })
      };
    }

    commit('user/fetchRequest', true, { root: true });
    let { data } = await ApiService.post(url, mail);
    if (data.success) {
      result = true;
      commit(
        'user/setSuccess',
        { isSuccess: true, successMessage: 'Correo Masivo enviado con éxito' },
        { root: true }
      );
    }
  } catch (err) {
    commit(
      'user/setError',
      {
        isError: true,
        errorMessage: err.response ? err.response.data.message : err.message
      },
      { root: true }
    );
    result = false;
  } finally {
    commit('user/finishRequest', null, { root: true });
  }
  return result;
};

export const fetchCorreoAddImagen = async ({ commit }, file) => {
  const formData = new FormData();
  formData.append('file', file);

  const url = ApiService.getEndpoint('/admin/usuarioUNI/correo-masivo/image');

  let { data } = await ApiService.customRequest({
    url: url,
    method: 'POST',
    data: formData
  });

  return data.data;
};

export const fetchEstadisticasLogin = async ({ commit }) => {
  let result = false;
  commit('user/initRequest', null, { root: true });
  const url = ApiService.getEndpoint('/admin/estadisticas/login');
  try {
    commit('user/fetchRequest', true, { root: true });
    let {
      data: { data }
    } = await ApiService.get(url);
    result = { ...data };
  } catch (err) {
    commit(
      'user/setError',
      {
        isError: true,
        errorMessage: err.response ? err.response.data.message : err.message
      },
      { root: true }
    );
    result = false;
  } finally {
    commit('user/finishRequest', null, { root: true });
  }
  return result;
};

export const fetchUpdateAdminInformation = async ({ commit }, body) => {
  commit('user/initRequest', null, { root: true });
  let result = false;
  const url = ApiService.getEndpoint('/admin/editar-admin');
  try {
    // Si no se está actualizando el campo de password
    if (!body.password) delete body.password;
    if (body._id) {
      body.adminId = body._id;
      delete body._id;
    }
    commit('user/fetchRequest', true, { root: true });
    let { data } = await ApiService.post(url, body);
    console.log('updatedAdmin', data);
    result = true;
  } catch (err) {
    commit(
      'user/setError',
      {
        isError: true,
        errorMessage: err.response ? err.response.data.message : err.message
      },
      { root: true }
    );
    result = false;
  } finally {
    commit('user/finishRequest', null, { root: true });
  }
  return result;
};

export const fetchUpdateAdminPassword = async ({ commit }, body) => {
  commit('user/initRequest', null, { root: true });
  let result = false;
  const url = ApiService.getEndpoint('/admin/cambiar-password');
  try {
    commit('user/fetchRequest', true, { root: true });
    let { data } = await ApiService.post(url, body);
    console.log('passwordRequest', data);
    result = true;
  } catch (err) {
    commit(
      'user/setError',
      {
        isError: true,
        errorMessage: err.response ? err.response.data.message : err.message
      },
      { root: true }
    );
    result = false;
  } finally {
    commit('user/finishRequest', null, { root: true });
  }
  return result;
};

export const fetchCreateAdmin = async ({ commit }, body) => {
  commit('user/initRequest', null, { root: true });
  let result = false;
  const url = ApiService.getEndpoint('/admin/crear-admin');
  try {
    commit('user/fetchRequest', true, { root: true });
    let response = await ApiService.post(url, body);
    if (response) {
      commit(
        'user/setSuccess',
        {
          isSuccess: true,
          successMessage: 'Administrador Creado'
        },
        { root: true }
      );
    }
    result = true;
  } catch (err) {
    commit(
      'user/setError',
      {
        isError: true,
        errorMessage: err.response ? err.response.data.message : err.message
      },
      { root: true }
    );
    result = false;
  } finally {
    commit('user/finishRequest', null, { root: true });
  }
  return result;
};

export const uploadCargaMasiva = async ({ commit }, body) => {
  commit('user/initRequest', null, { root: true });
  let result = false;
  const url = ApiService.getEndpoint('/admin/usuarioUNI/actualizar-adjunto');
  try {
    commit('user/fetchRequest', true, { root: true });
    let formData = new FormData();
    formData.append('adjunto', body.adjunto);
    formData.append('update', body.update);
    let response = await ApiService.post(url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    if (body.update) {
      commit(
        'user/setSuccess',
        {
          isSuccess: true,
          successMessage: 'Subido exitosamente'
        },
        { root: true }
      );
      result = true;
    } else {
      result = response.data.data;
    }
  } catch (err) {
    commit(
      'user/setError',
      {
        isError: true,
        errorMessage: err.response ? err.response.data.message : err.message
      },
      { root: true }
    );
    result = false;
  } finally {
    commit('user/finishRequest', null, { root: true });
  }
  return result;
};

export const fetchNewAddImagen = async ({ commit }, file) => {
  const formData = new FormData();
  formData.append('file', file);

  const url = ApiService.getEndpoint('/admin/news/image');

  let { data } = await ApiService.customRequest({
    url: url,
    method: 'POST',
    data: formData
  });

  return data.data;
};

export const fetchCreateNew = async ({ commit }, body) => {
  commit('user/initRequest', null, { root: true });
  let result = false;
  const url = ApiService.getEndpoint('/admin/news');
  try {
    commit('user/fetchRequest', true, { root: true });
    let response = await ApiService.post(url, body);
    if (response) {
      commit(
        'user/setSuccess',
        {
          isSuccess: true,
          successMessage: 'Noticia Creada'
        },
        { root: true }
      );
    }
    result = true;
  } catch (err) {
    commit(
      'user/setError',
      {
        isError: true,
        errorMessage: err.response ? err.response.data.message : err.message
      },
      { root: true }
    );
    result = false;
  } finally {
    commit('user/finishRequest', null, { root: true });
  }
  return result;
};

export const fetchListaNew = async ({ commit }) => {
  let result = false;
  commit('user/initRequest', null, { root: true });
  const url = ApiService.getEndpoint('/admin/news');

  try {
    commit('user/fetchRequest', true, { root: true });
    let { data } = await ApiService.get(url);
    commit('setListaNews', data);
    result = true;
  } catch (err) {
    commit(
      'user/setError',
      {
        isError: true,
        errorMessage: err.response ? err.response.data.message : err.message
      },
      { root: true }
    );
    result = false;
  } finally {
    commit('user/finishRequest', null, { root: true });
  }
  return result;
};
